import { useLayoutEffect, useRef, useState } from 'react';
import { isDark, useTheme } from '../lib/theme';

/** A band of 40px pixels, the same cells and pattern as serverscamp.com: under the sign-in brand side and the onboarding. */
export function Pixels({ className }: { className: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [cols, setCols] = useState(0);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver(() => setCols(Math.ceil(el.clientWidth / 40)));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  const { theme } = useTheme();
  const C = theme === 'graphite'
    ? { brand: 'oklch(0.5 0.13 145)', g300: 'oklch(0.19 0.007 240)', g400: 'oklch(0.22 0.008 240)', g500: 'oklch(0.26 0.009 240)', g700: 'oklch(0.31 0.009 240)' }
    : isDark(theme)
    ? { brand: '#1f5434', g300: '#141414', g400: '#1b1b1b', g500: '#232323', g700: '#2e2e2e' }
    : { brand: '#1d7a3e', g300: '#dedddb', g400: '#cbcac8', g500: '#a9a8a5', g700: '#6e6e6d' };
  const rows = [
    { y: 0, c: C.g300, d: 0.14, b: 0 },
    { y: 40, c: C.g400, d: 0.26, b: 0.06 },
    { y: 80, c: C.g500, d: 0.42, b: 0.1 },
    { y: 120, c: C.g700, d: 0.6, b: 0.12 },
  ];
  let seed = 23;
  const rnd = () => { seed = (seed * 16807) % 2147483647; return seed / 2147483647; };
  const cells: { x: number; y: number; c: string }[] = [];
  rows.forEach((r) => {
    for (let x = 0; x < cols; x++) {
      if (rnd() >= r.d) continue;
      cells.push({ x: x * 40, y: r.y, c: rnd() < r.b ? C.brand : r.c });
    }
  });
  return (
    <div className={className} ref={ref} aria-hidden="true">
      {cells.map((p, i) => <i key={i} style={{ left: p.x, top: p.y, background: p.c }} />)}
    </div>
  );
}
